import i18next from 'i18next';

import alerts from 'common/modules/alerts';

import restartPassword from './restartPassword';

export default (filterData, values) => (dispatch) => {
    const dataAlert = {
        confirmText: i18next.t('Restore password'),
        messages: [
            i18next.t('Are you really sure about resetting the password?'),
        ],
        onSuccess: () => dispatch(restartPassword(filterData, values)),
        title: i18next.t('Confirmation'),
        type: alerts.ALERT_TYPE_CONFIRM,
        variant: 'warning',
    };

    dispatch(alerts.actions.show(dataAlert));
};
